<script setup lang="ts">
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { ref, watch } from 'vue';
import OneMarketCard from './OneMarketCard.vue';
import MultipleMarketsCard from './MultipleMarketsCard.vue';

const props = defineProps({
    loading: {
        type: Boolean,
        default: false
    },
    defaultValue: {
        type: String,
        default: "standard"
    },
    yearly: {
        type: Boolean,
        default: false
    }
})

const defaultTabs = [
    {
        value: "standard",
        label: "One Market"
    },
    {
        value: "enterprise",
        label: "Multiple Markets"
    }
]

const emit = defineEmits(['update:plan'])

const activeTab = ref(props.defaultValue)

watch(() => props.defaultValue, (val) => {
    if (val) {
        activeTab.value = val
    }
}, { immediate: true })

const updatePlan = (plan) => {
    emit('update:plan', plan)
}
</script>

<template>
    <Tabs v-model="activeTab" class="w-full">
        <div class="w-full flex justify-center mt-10">
            <TabsList class="bg-general-accent">
                <TabsTrigger v-for="tab in defaultTabs" :key="tab.value" :value="tab.value">
                {{ tab.label }}
                </TabsTrigger>
            </TabsList>
        </div>
        <TabsContent v-for="tab in defaultTabs" :key="tab.value" :value="tab.value">
            <template v-if="tab.value === 'standard'">
                <OneMarketCard :loading="loading" :yearly="yearly" @select:plan="updatePlan"/>
            </template>
            <template v-else-if="tab.value === 'enterprise'">
                <MultipleMarketsCard :loading="loading" @select:plan="updatePlan" />
            </template>
        </TabsContent>
    </Tabs>
</template>
